import { apiFetch } from "../utils/apiFetch";
import { API_BASE_ADMIN } from "../config/vars";

export const fetchServices = async () => {
    const response = await apiFetch(`${API_BASE_ADMIN}/services/admin`);
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || "Не вдалося завантажити сервіси");
    }
    return response.json();
};

export const fetchNetworks = async () => {
    const response = await apiFetch(`${API_BASE_ADMIN}/networks/admin/active`);
    if (!response.ok) throw new Error("Не вдалося завантажити мережі");
    return response.json();
};

export const updateService = async (id, data) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/services/admin/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || "Не вдалося оновити сервіс");
    }
    return response.json();
};

export const createService = async (data) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/services/admin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || "Не вдалося додати сервіс");
    }
    return response.json();
};